// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".circle-mask[data-v-f99de37c]{-o-object-fit:cover;object-fit:cover;min-width:50px;height:50px;clip-path:circle(50% at 50% 50%)}@media (min-width:1024px){.circle-mask[data-v-f99de37c]{min-width:65px;height:65px}}", ""]);
// Exports
module.exports = exports;
